import React from 'react';
import {File as FWFile} from 'FW/Models/File';
import InlineEditableElement from 'Components/InlineEditableElement';
import _ from 'underscore';

class JumbotronCarousel extends React.Component{

  constructor(){
    super(...arguments);
    this.slideActionClicked = this.slideActionClicked.bind(this);
  }

  slideActionClicked(e){
    e.preventDefault();
    e.stopPropagation();
  }

  componentDidMount(){
    this.props.section.on('change', () => {
      this.forceUpdate();
    }, this);
  }

  componentWillUnmount(){
    this.props.section.off(null, null, this);
  }

  slideChanged(slideIndex, value){
    let slides = _.clone(this.props.section.prop('slides'));
    slides[slideIndex].content = value;
    this.props.section.prop('slides', slides);
  }

  getFilteredSlides = () => {
    return _.filter(this.props.section.prop('slides'), function(slide){
      return FW.inEditor() || slide.hide_slide !== true;
    });
  };

  render(){
    let section = this.props.section;
    let slideIndicators = this.getFilteredSlides().map((slide, i) => {
      let className = i === 0 ? 'active' : '';
      return <li key={`slide-indicator-${i}`} onClick={this.slideActionClicked} className={className} data-target={`#carousel-${section.get('id')}`} data-slide-to={i}/>;
    });

    let slides = this.getFilteredSlides().map((slide, i) => {
      let backgroundUrl = null;
      if (slide.background_file_id){
        let background = FWFile.findOrCreate({id: slide.background_file_id});
        backgroundUrl = background.helper.thumbnailUrl(2880);
      }
      let className = i === 0 ? 'item active' : 'item';

      return <div key={`slide-${i}`} className={className} style={{height: '100%', backgroundImage: 'url(' + backgroundUrl + ')'}}>
        <div className="caption" style={{height: '100%'}}>
          <div className="jumbotron" style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: slide.background, display: 'table'}}>
            <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
              <InlineEditableElement className="container" html={slide.content || ''} onChange={this.slideChanged.bind(this, i)} inlineEditingEnabled={this.props.inlineEditingEnabled} />
            </div>
          </div>
        </div>
      </div>;
    });
    return (
      <div className="carousel slide carousel-fade home-slider" id={`carousel-${section.get('id')}`} data-ride="carousel" data-interval={FW.inEditor() ? false : 5000} style={{height: '660px'}}>
        <ol className="carousel-indicators">
          {slideIndicators}
        </ol>
        <div className="carousel-inner">
          {slides}
        </div>
        <a className="left-control" href={`#carousel-${section.get('id')}`} onClick={this.slideActionClicked} data-slide="prev"><i className="fa fa-angle-left"/></a>
        <a className="right-control" href={`#carousel-${section.get('id')}`} onClick={this.slideActionClicked} data-slide="next"><i className="fa fa-angle-right"/></a>
      </div>
    );
  }

}

export default JumbotronCarousel;
